module.exports = __webpack_public_path__ + "img/kvalitetselement_biologiske.28435582.jpg";